import { POSITIONING } from './tooltipConstants';

/**
 * Calculates spotlight position for highlighting target element
 */
export const calculateSpotlightPosition = (element) => {
  if (!element) return null;

  const rect = element.getBoundingClientRect();
  const padding = POSITIONING.SPOTLIGHT_PADDING;

  return {
    top: rect.top - padding,
    left: rect.left - padding,
    width: rect.width + padding * 2,
    height: rect.height + padding * 2,
  };
};

/**
 * Steps that light a region inside their target rather than the whole thing.
 * "Choosing Chart Data" anchors on the Smart Chart window so the card can sit
 * beside it, but the slide is about the checkbox column on the window's left —
 * so the spotlight frames the column and the dim falls on everything else.
 */
export const SPOTLIGHT_SELECTOR_BY_STEP = {
  precharting_overview: '[data-tutorial="prechart_field_list"]',
};

/**
 * Resolves what the spotlight cut-out should frame for a step
 * @param {string} stepId - Current step ID
 * @param {Element|null} element - The step's own target element
 * @returns {Element|null} - The inner region when the step names one and it is
 *   mounted, otherwise the step's target
 */
export const spotlightTarget = (stepId, element) => {
  const selector = SPOTLIGHT_SELECTOR_BY_STEP[stepId];
  if (!selector) return element;
  return document.querySelector(selector) || element;
};
